<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 5C4 3.34315 5.34315 2 7 2H19C19.5523 2 20 2.44772 20 3V17C20 17.5523 19.5523 18 19 18V20C19.5523 20 20
      20.4477 20 21C20 21.5523 19.5523 22 19 22H7C5.34315 22 4 20.6569 4 19V5ZM7 4C6.44772 4 6 4.44771 6 5V16H18V4H7ZM6
      19C6 18.4477 6.44772 18 7 18H17V20H7C6.44771 20 6 19.5523 6 19ZM11 6C9.89543 6 9 6.89543 9 8V13C9 13.5523 9.44771
      14 10 14C10.5523 14 11 13.5523 11 13V12H13C14.1046 12 15 11.1046 15 10V8C15 6.89543 14.1046 6 13 6H11ZM11 8.5C11
      8.22386 11.2239 8 11.5 8H12.5C12.7761 8 13 8.22386 13 8.5V9.5C13 9.77614 12.7761 10 12.5 10H11.5C11.2239 10 11
      9.77614 11 9.5V8.5Z"
    />
  </svg>
</template>
